import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthContextProvider } from './adminlogin/AuthContext';
import { ReligionContextProvidor } from './admin/religion/ReligionContext';
import { CasteContextProvidor } from './admin/caste/CasteContext';
import { StudentAuthContextProvider } from './student/StudentAuthContext';
import { StudentContextProvidor } from './admin/student/StudentContext';
import { SubCasteContextProvidor } from './admin/subcaste/SubCasteContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  
        <AuthContextProvider>
        <StudentAuthContextProvider>
               <ReligionContextProvidor>
                    <CasteContextProvidor>
                        <SubCasteContextProvidor>
                              <StudentContextProvidor>
                                    <App />
                              </StudentContextProvidor>
                        </SubCasteContextProvidor>
                     
                    </CasteContextProvidor>
              </ReligionContextProvidor>
        </StudentAuthContextProvider>
        </AuthContextProvider>
   
  </React.StrictMode>
);
